import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { FsMessage } from '@firestitch/message';

import { AclService } from '@app/core';


@Injectable()
export class FormSubmissionsGuard  {
  private _aclQueryService = inject(AclService);
  private _router = inject(Router);
  private _message = inject(FsMessage);


  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    return this._router.createUrlTree([
      '/forms',
      route.params.formId,
      'submissions',
      route.params.formSubmissionId,
    ]);
  }

}
